












import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'GExamDetailProgressClassTableEvalCell',
  computed: {},
  methods: {},
})
export default class GExamDetailProgressTableEvalCell extends Vue {
  @Prop() required: boolean;
  @Prop() completed: boolean;
  mounted() {}
}
